import React from 'react';
import PropTypes from 'prop-types';

const COIConflict = ({ row }) => {
  const { coiTypes } = row.original;

  if (!coiTypes) return null;

  const categoryMatch = coiTypes.match(/^([^:]+):\s*(.*)$/);

  if (categoryMatch) {
    const [, category, types] = categoryMatch;
    return (
      <div>
        <b>{category}:</b> {types}
      </div>
    );
  }

  return <div>{coiTypes}</div>;
};

COIConflict.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      coiTypes: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default COIConflict;
